module.exports = __webpack_public_path__ + "static/media/mikaeilshaghelani.b6056939.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/mikaeilshaghelani.webp
// module id = 899
// module chunks = 0